import { FetchError } from '../errors/FetchError'
import { fetchWithAuthorization } from './fetch'

export const createVigilant = async (obj) => {
  try {
    const data = await fetchWithAuthorization('/safety', obj, 'POST')
    return data
  } catch (error) {
    throw new FetchError(error, 'Http call to Create vigilant failed')
  }
}

export const editVigilant = async (auth_id, obj) => {
  try {
    const data = await fetchWithAuthorization(`/profile/${auth_id}`, obj, 'PUT')
    return data
  } catch (error) {
    throw new FetchError(error, 'Http call to Edit vigilant failed')
  }
}

export const deleteVigilant = async (vigilant) => {
  try {
    const data = await fetchWithAuthorization(`/safety/${vigilant}`, null, 'DELETE')
    return data
  } catch (error) {
    throw new FetchError(error, 'Http call to Delete vigilant failed')
  }
}

export const getAllVigilants = async (page, limit = 10, params) => {
  const { isProvider, condominium, search } = params

  try {
    let url = `/safety?condominium=${condominium}&page=${page}&limit=${limit}`

    if (isProvider) url += `&isProvider=${isProvider}`
    const term = typeof search === 'string' ? search.trim() : ''
    if (term) url += `&search=${encodeURIComponent(term)}`

    const data = await fetchWithAuthorization(url)

    return data
  } catch (error) {
    throw new FetchError(error, 'This is a custom error in getAllVigilants')
  }
}

export const getVigilant = async (vigilant) => {
  try {
    const data = await fetchWithAuthorization(`/safety/${vigilant}`, null, 'GET')
    return data
  } catch (error) {
    throw new FetchError(error, 'Http call to Delete vigilant failed')
  }
}
